<template>
  <div id="vue-app">
    <access-modal ref="accessModal"></access-modal>
    <router-view />
  </div>
</template>

<script>
  import EventBus, { OPEN_ACCESS_LAYER } from "./event-bus.js";
  import AccessModal from "@c/AccessModal.vue";
  import _ from "lodash";

  export default {
    name: "App",
    components: {
      AccessModal,
    },
    mounted() {
      var self = this;
      EventBus.$on(
        OPEN_ACCESS_LAYER,
        async function (formulartyp_key, titel, gueltig_bis, ...ref_ids) {
          await self.$refs.accessModal.show(
            formulartyp_key,
            titel,
            gueltig_bis,
            _.flatten(ref_ids)
          );
        }
      );
    },
  };
</script>

<style lang="scss">
  body {
    touch-action: pan-x pan-y;
  }
  @import "./styles/scss/app.scss";
</style>
